var app = angular.module('leonardo');

var LanguageService = function(BaseRestService) {
  var service = new BaseRestService('languages');
  return service;
};

app.factory('LanguageService', ['BaseRestService', LanguageService]);

